module.exports = __webpack_public_path__ + "img/step2.f4b195a7.png";